/* eslint-disable react/prefer-es6-class, react/sort-comp */
import React from 'react';
import { NavButton, Navigation } from 'es6/components/apps/navigation';
import Localization from 'es6/services/localization';
import ResultGlyphs from 'es6/components/apps/result-glyphs';

export default React.createClass({
  displayName: 'PlacementSessionResultsScreen',

  /**
   * Results should be an array of objects that look like:
   * [
   *  {
   *    cue: 'some item package name',
   *    response: '',
   *    isCorrect: true|false
   *  },
   *  ...
   * ]
   */
  propTypes: {
    results: React.PropTypes.array.isRequired,
    onBack: React.PropTypes.func.isRequired,
  },

  render() {
    return (
      <div className="screen screen-placement-session-results">
        <div className="screen-content screen-content-scrollable">
          <h3 className="header">{Localization.t('your quiz results')}</h3>

          <table className="results">
            <thead className="results-header">
              <tr className="results-row">
                <th className="results-cue">{Localization.t('item')}</th>
                <th className="results-response">{Localization.t('translation')}</th>
                <th className="results-answer">{Localization.t('your answer')}</th>
              </tr>
            </thead>

            <tbody className="results-body">
              {this.props.results.map((result, index) => this._renderResult(result, index))}
            </tbody>
          </table>
        </div>

        <Navigation>
          <NavButton align="left" onClick={this.props.onBack}>{Localization.t('back')}</NavButton>
        </Navigation>
      </div>
    );
  },

  _renderResult(result, key) {
    return (
      <tr key={key} className="results-row">
        <td className="results-cue">{result.cue}</td>
        <td className="results-response">{result.response}</td>
        <td className="results-answer">{this._renderGlyph(result.isCorrect)}</td>
      </tr>
    );
  },

  _renderGlyph(isCorrect) {
    if (isCorrect) {
      return (<div className={ResultGlyphs.CORRECT} />);
    }

    return (<div className={ResultGlyphs.INCORRECT} />);
  },
});
